import React, { useRef } from "react";
import { motion, useInView, useReducedMotion } from "framer-motion";
import {
  CHANNELS,
  CHANNELS_HEADLINE,
  CHANNELS_PAYOFF,
  CHANNELS_SCAN_LINE,
  CHANNELS_STAMP,
  CHANNELS_TAG,
  CHANNELS_WORKFLOW,
} from "../shared/channelsContent.js";

const QuietChannelsSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-80px" });
  const reduceMotion = useReducedMotion();

  return (
    <section className="cursor-section cursor-channels-section" data-testid="quiet-channels-section" ref={ref}>
      <div className="cursor-channels-glow" aria-hidden="true" />
      <div className="cursor-container cursor-channels-inner">
        <div className="cursor-channels-header">
          <div className="cursor-channels-stamp-row">
            <span className="cursor-channels-stamp">{CHANNELS_STAMP}</span>
            <span className="cursor-channels-live-dot" aria-hidden="true">
              <span className="cursor-channels-live-ping" />
              <span className="cursor-channels-live-core" />
            </span>
            <span className="cursor-channels-scan-tag">{CHANNELS_TAG}</span>
          </div>
          <p className="cursor-channels-scan-line">{CHANNELS_SCAN_LINE}</p>
          <h2 className="cursor-channels-title" data-testid="quiet-channels-headline">
            {CHANNELS_HEADLINE.lead}{" "}
            <span className="cursor-channels-title-accent">{CHANNELS_HEADLINE.accent}</span>
          </h2>
        </div>

        <div className="cursor-channels-grid" data-testid="quiet-channels-pills">
          {CHANNELS.map((channel, index) => (
            <motion.div
              key={channel.id}
              className={`cursor-channels-card${channel.highlight ? " cursor-channels-card-hero" : ""}`}
              data-testid={`quiet-channel-${channel.id}`}
              initial={reduceMotion ? false : { opacity: 0, y: 10 }}
              animate={reduceMotion || isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 10 }}
              transition={{ duration: 0.35, delay: index * 0.06 }}
            >
              {channel.highlight && (
                <span className="cursor-channels-card-key">KEY CHANNEL</span>
              )}
              <p className="cursor-channels-card-name">{channel.name}</p>
              <p className="cursor-channels-card-tag">{channel.tag}</p>
            </motion.div>
          ))}
        </div>

        <div className="cursor-channels-workflow" data-testid="quiet-channels-workflow">
          {CHANNELS_WORKFLOW.map((item) => (
            <div key={item.step} className="cursor-channels-workflow-step">
              <span className="cursor-channels-workflow-label">{item.step}</span>
              <span className="cursor-channels-workflow-text">{item.text}</span>
            </div>
          ))}
        </div>

        <p className="cursor-channels-payoff" data-testid="quiet-channels-payoff">
          {CHANNELS_PAYOFF}
        </p>
      </div>
    </section>
  );
};

export default QuietChannelsSection;
